module.exports = __webpack_public_path__ + "img/b538e02.svg";